export const demoTSData = {
  uuid: "d6ad1878191d45738b2647d72c37e556",
  title: "Initial V1.2",
  identifier: "23127107TC.OMAR",
  version: 1.2,
  upperSteps: 27,
  lowerSteps: 66,
  sync: "Start together",
  irregularities: "2",
  severity: "Mild",
  wearCycle: "1 Week",
  iprSheet:
    "https://eon-manufacturing-dev.s3.eu-central-1.amazonaws.com/public/eon-mfg/23127107TC.OMAR/attachedFiles/treatment-summary-pdf-1706707506512?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC65JH6RHY%2F20240201%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20240201T071851Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEHcaDGV1LWNlbnRyYWwtMSJIMEYCIQDQABffZ%2BZozziD4Pp9Cg%2B4PbLkMeG0F5vV9rwxH2Ir5wIhALtCY%2F3KXaHiaYS0tAdcn0mxeIXQpVlGaBR5w9cBrMddKskFCEAQAxoMNjkzODc4OTk1Mzk3IgxZXujrA775njhI3SkqpgUmaA6intM%2FJV3A%2BGrfMzHY%2FaaBowTBAWPACWTlU8x%2BP35MOHgMZyKZAXgFzCtTljf%2BxZI3vQKmIJ6chsGt3EbW5LBRNpjkCa0eZA3NU4rXpd%2F6Ld5G%2Fg3nxvDPImQryQtUsEP5tSU3H3k922XWLnL9XSYsMAwIB7wv%2BNJb56pz4xGpljFv4NRGGi9st3U23slY7%2Fo1e0pDXCdTpqO7bNAWxwo5sXVRKaYp7rq7q3N4IVUvTMKQ0UQCWMT%2BSxHzfLNVcJbHqvMmUyDJf6S0ift8opzzFtPZfaoOKV6DFvnOGRzZv2nPfeVFcglWcf4TnXIQhPM8S%2BM1ncGdSBsyz5tCUW6W7SrNobGFqlr1WuYuyONiUKn%2FX6Mo6hCKxXCfQDo85GtdAKSoBRjOsqovEM%2F7fICFtSaJyM5T6%2Fk2ssso%2FKsEj6i8PycWp3AiHrf%2FnzlwyAoykpnJH75GxHKU6bDdePUy%2FBnGXXwaSia68f8rNEEpJH%2BfTV%2FNT%2FIgHGQA2D6opCTrQLCWVFK5rF6vXvCGEke7pq070F7ZwlOYhYnMvz8LZKxjzPrPMshLczdzp7d3Y8U%2FEen1GSvpKzHWNzRhGXW11qy2VwXSq64C7OsM%2FyuvBPZtBF2MM21wK4TLIWV4UakHjJepWD%2BtQEDnpCDOpA%2FqTbSyHyiBspcP8HydIH3e%2FSnvNcxYAGtdygbfSUQ%2BPFX04db5cJLOYP%2Fv%2Ftf72NWzvjzWgwzaRiPEKvZon8QnPRbPjzA4HJ7vT0jV3Oe1Kw%2BjJwtD6KC3s723SGYjGvNbrFO74ytkuLQVjH0TiCem33A%2Fb1hb9lRAI8%2F99LIs30XxJSSv2Pv0pxJhH7kpvZJyP2mc3j2sSwz03rajxfCQdncF5TYX8Hu%2FHV%2FgWRe0rk88taIwwvbsrQY64gIDDEeOUtE7GlIpfwvBpNPnGiDoKkFNIEYE2%2FXwMREE0Vh%2FZnKpUApp6uybAZHo7%2FgUN3q4I3u6wHWbUEPKDRnQHQAX1eV4kQktPGvOLVfFQVt23j3nc1DMZE35CYtpPqavWuqec4QtIEt%2F21%2BYqjoyyC3pGJ3x8bX9x2oSQlJJeeeaBlVgYlInbOWf2tJZfVG4Z7LucbUJ57z33k8h3YGeF8r09TyfgrdT1eW2ewXd40cGL9v7A6ng1sHJzBJMoHj1j3Xvl9N1k1U4CuRcls2R0DPdLnq2rmyImO2%2F9Uq%2F37W77%2BH%2Bn44wWk4YPNbNk8JR6MuzxmO4HV8K7jLAeALS%2Bx%2Fgl33A9vL0S5nYpJzuJmbuh2yPlFQMIQSmPbZxOoPoysSVEtsOor%2FjIvlAuEDtdParkZWwa6pTEyi53VwWqcv40b8IPMRSNzkM11rW%2FUNej7Q4%2BYbtw1u8K%2F7Sw4SKonU%3D&X-Amz-Signature=7ed757c2ec80001e6728f93ac43bfb92928aa6a15099045b56111d567ed328d5&X-Amz-SignedHeaders=host",
  attachmentsSheet: null,
  rejectionReason: null,
  clearanceRejectionReason: null,
  viewerHash:
    "921abc3b7c9630f79b23ca4a203a5541e02e527b30ec30aa2cf4756d7f254f02d82c6cce0fb5fa855bacdd5a03d84f30fd4837ecb4ab8b47bf3117f58b3422f8a83b75b217534e5cbd6015bf1921f5f480684d60792127f7ac75037e8c1138191adf5406b2c57bfbdb3da7aca5d17d6bd9fcee5726482f0c53fab575c4a8a4ce13b5abc95530b289fdb4ec57b5fe94e7c3c8998f227735d24396f20883bbf6bf39cbbeb0cc59c293fb3f49d665850b0a4d9dfcb4874e6b2c96fe09618bdce726",
  notes: "",
  otpFileUrl:
    "https://eon-manufacturing-dev.s3.eu-central-1.amazonaws.com/public/1067/1164/1706707158685_otpFile.otp?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC65JH6RHY%2F20240201%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20240201T071851Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEHcaDGV1LWNlbnRyYWwtMSJIMEYCIQDQABffZ%2BZozziD4Pp9Cg%2B4PbLkMeG0F5vV9rwxH2Ir5wIhALtCY%2F3KXaHiaYS0tAdcn0mxeIXQpVlGaBR5w9cBrMddKskFCEAQAxoMNjkzODc4OTk1Mzk3IgxZXujrA775njhI3SkqpgUmaA6intM%2FJV3A%2BGrfMzHY%2FaaBowTBAWPACWTlU8x%2BP35MOHgMZyKZAXgFzCtTljf%2BxZI3vQKmIJ6chsGt3EbW5LBRNpjkCa0eZA3NU4rXpd%2F6Ld5G%2Fg3nxvDPImQryQtUsEP5tSU3H3k922XWLnL9XSYsMAwIB7wv%2BNJb56pz4xGpljFv4NRGGi9st3U23slY7%2Fo1e0pDXCdTpqO7bNAWxwo5sXVRKaYp7rq7q3N4IVUvTMKQ0UQCWMT%2BSxHzfLNVcJbHqvMmUyDJf6S0ift8opzzFtPZfaoOKV6DFvnOGRzZv2nPfeVFcglWcf4TnXIQhPM8S%2BM1ncGdSBsyz5tCUW6W7SrNobGFqlr1WuYuyONiUKn%2FX6Mo6hCKxXCfQDo85GtdAKSoBRjOsqovEM%2F7fICFtSaJyM5T6%2Fk2ssso%2FKsEj6i8PycWp3AiHrf%2FnzlwyAoykpnJH75GxHKU6bDdePUy%2FBnGXXwaSia68f8rNEEpJH%2BfTV%2FNT%2FIgHGQA2D6opCTrQLCWVFK5rF6vXvCGEke7pq070F7ZwlOYhYnMvz8LZKxjzPrPMshLczdzp7d3Y8U%2FEen1GSvpKzHWNzRhGXW11qy2VwXSq64C7OsM%2FyuvBPZtBF2MM21wK4TLIWV4UakHjJepWD%2BtQEDnpCDOpA%2FqTbSyHyiBspcP8HydIH3e%2FSnvNcxYAGtdygbfSUQ%2BPFX04db5cJLOYP%2Fv%2Ftf72NWzvjzWgwzaRiPEKvZon8QnPRbPjzA4HJ7vT0jV3Oe1Kw%2BjJwtD6KC3s723SGYjGvNbrFO74ytkuLQVjH0TiCem33A%2Fb1hb9lRAI8%2F99LIs30XxJSSv2Pv0pxJhH7kpvZJyP2mc3j2sSwz03rajxfCQdncF5TYX8Hu%2FHV%2FgWRe0rk88taIwwvbsrQY64gIDDEeOUtE7GlIpfwvBpNPnGiDoKkFNIEYE2%2FXwMREE0Vh%2FZnKpUApp6uybAZHo7%2FgUN3q4I3u6wHWbUEPKDRnQHQAX1eV4kQktPGvOLVfFQVt23j3nc1DMZE35CYtpPqavWuqec4QtIEt%2F21%2BYqjoyyC3pGJ3x8bX9x2oSQlJJeeeaBlVgYlInbOWf2tJZfVG4Z7LucbUJ57z33k8h3YGeF8r09TyfgrdT1eW2ewXd40cGL9v7A6ng1sHJzBJMoHj1j3Xvl9N1k1U4CuRcls2R0DPdLnq2rmyImO2%2F9Uq%2F37W77%2BH%2Bn44wWk4YPNbNk8JR6MuzxmO4HV8K7jLAeALS%2Bx%2Fgl33A9vL0S5nYpJzuJmbuh2yPlFQMIQSmPbZxOoPoysSVEtsOor%2FjIvlAuEDtdParkZWwa6pTEyi53VwWqcv40b8IPMRSNzkM11rW%2FUNej7Q4%2BYbtw1u8K%2F7Sw4SKonU%3D&X-Amz-Signature=07ec10ccb374363e920641de7e3af7274f0abdec25eb42c42bbfa7cdd8f9c77e&X-Amz-SignedHeaders=host",
  retainers: 0,
  prodFile: null,
  status: "CONVERTED",
  upperOvercorrectionSteps: 0,
  lowerOvercorrectionSteps: 0,
  upperTemplates: null,
  lowerTemplates: null,
  missingTeeth: {},
  movementTable: [
    {
      "Tooth number": "14",
      Rotation: "6.00 deg",
      Angulation: "",
      Inclination: "6.00 deg",
      "Left/ Right": "0.60 mm",
      "Extrusion/ Intrusion": "-0.20 mm",
      "Forward/ Backward": "1.85 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "75.3 deg",
      Circumference: "26.7 mm",
    },
    {
      "Tooth number": "13",
      Rotation: "21.98 deg",
      Angulation: "10.00 deg",
      Inclination: "",
      "Left/ Right": "-0.98 mm",
      "Extrusion/ Intrusion": "-0.43 mm",
      "Forward/ Backward": "1.11 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "67.8 deg",
      Circumference: "24.6 mm",
    },
    {
      "Tooth number": "12",
      Rotation: "-23.43 deg",
      Angulation: "1.00 deg",
      Inclination: "2.00 deg",
      "Left/ Right": "0.92 mm",
      "Extrusion/ Intrusion": "-0.31 mm",
      "Forward/ Backward": "0.60 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "67.2 deg",
      Circumference: "20.4 mm",
    },
    {
      "Tooth number": "11",
      Rotation: "-14.86 deg",
      Angulation: "2.00 deg",
      Inclination: "-2.00 deg",
      "Left/ Right": "0.06 mm",
      "Extrusion/ Intrusion": "-0.54 mm",
      "Forward/ Backward": "1.43 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "65.1 deg",
      Circumference: "24.0 mm",
    },
    {
      "Tooth number": "21",
      Rotation: "-5.48 deg",
      Angulation: "",
      Inclination: "5.00 deg",
      "Left/ Right": "0.49 mm",
      "Extrusion/ Intrusion": "-0.61 mm",
      "Forward/ Backward": "1.17 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "67.9 deg",
      Circumference: "24.5 mm",
    },
    {
      "Tooth number": "22",
      Rotation: "-46.74 deg",
      Angulation: "-8.35 deg",
      Inclination: "15.26 deg",
      "Left/ Right": "1.30 mm",
      "Extrusion/ Intrusion": "-0.13 mm",
      "Forward/ Backward": "-0.70 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "65.2 deg",
      Circumference: "20.4 mm",
    },
    {
      "Tooth number": "23",
      Rotation: "",
      Angulation: "",
      Inclination: "",
      "Left/ Right": "-0.16 mm",
      "Extrusion/ Intrusion": "-0.01 mm",
      "Forward/ Backward": "0.61 mm",
      "IPR Distal": "",
      "IPR Mesial": "",
      "Long Axis": "72.2 deg",
      Circumference: "24.2 mm",
    },
  ],
  movementTableUrl:
    "https://eon-manufacturing-dev.s3.eu-central-1.amazonaws.com/public/1067/1164/1706707152489_movement_table.html?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC65JH6RHY%2F20240201%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20240201T071851Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEHcaDGV1LWNlbnRyYWwtMSJIMEYCIQDQABffZ%2BZozziD4Pp9Cg%2B4PbLkMeG0F5vV9rwxH2Ir5wIhALtCY%2F3KXaHiaYS0tAdcn0mxeIXQpVlGaBR5w9cBrMddKskFCEAQAxoMNjkzODc4OTk1Mzk3IgxZXujrA775njhI3SkqpgUmaA6intM%2FJV3A%2BGrfMzHY%2FaaBowTBAWPACWTlU8x%2BP35MOHgMZyKZAXgFzCtTljf%2BxZI3vQKmIJ6chsGt3EbW5LBRNpjkCa0eZA3NU4rXpd%2F6Ld5G%2Fg3nxvDPImQryQtUsEP5tSU3H3k922XWLnL9XSYsMAwIB7wv%2BNJb56pz4xGpljFv4NRGGi9st3U23slY7%2Fo1e0pDXCdTpqO7bNAWxwo5sXVRKaYp7rq7q3N4IVUvTMKQ0UQCWMT%2BSxHzfLNVcJbHqvMmUyDJf6S0ift8opzzFtPZfaoOKV6DFvnOGRzZv2nPfeVFcglWcf4TnXIQhPM8S%2BM1ncGdSBsyz5tCUW6W7SrNobGFqlr1WuYuyONiUKn%2FX6Mo6hCKxXCfQDo85GtdAKSoBRjOsqovEM%2F7fICFtSaJyM5T6%2Fk2ssso%2FKsEj6i8PycWp3AiHrf%2FnzlwyAoykpnJH75GxHKU6bDdePUy%2FBnGXXwaSia68f8rNEEpJH%2BfTV%2FNT%2FIgHGQA2D6opCTrQLCWVFK5rF6vXvCGEke7pq070F7ZwlOYhYnMvz8LZKxjzPrPMshLczdzp7d3Y8U%2FEen1GSvpKzHWNzRhGXW11qy2VwXSq64C7OsM%2FyuvBPZtBF2MM21wK4TLIWV4UakHjJepWD%2BtQEDnpCDOpA%2FqTbSyHyiBspcP8HydIH3e%2FSnvNcxYAGtdygbfSUQ%2BPFX04db5cJLOYP%2Fv%2Ftf72NWzvjzWgwzaRiPEKvZon8QnPRbPjzA4HJ7vT0jV3Oe1Kw%2BjJwtD6KC3s723SGYjGvNbrFO74ytkuLQVjH0TiCem33A%2Fb1hb9lRAI8%2F99LIs30XxJSSv2Pv0pxJhH7kpvZJyP2mc3j2sSwz03rajxfCQdncF5TYX8Hu%2FHV%2FgWRe0rk88taIwwvbsrQY64gIDDEeOUtE7GlIpfwvBpNPnGiDoKkFNIEYE2%2FXwMREE0Vh%2FZnKpUApp6uybAZHo7%2FgUN3q4I3u6wHWbUEPKDRnQHQAX1eV4kQktPGvOLVfFQVt23j3nc1DMZE35CYtpPqavWuqec4QtIEt%2F21%2BYqjoyyC3pGJ3x8bX9x2oSQlJJeeeaBlVgYlInbOWf2tJZfVG4Z7LucbUJ57z33k8h3YGeF8r09TyfgrdT1eW2ewXd40cGL9v7A6ng1sHJzBJMoHj1j3Xvl9N1k1U4CuRcls2R0DPdLnq2rmyImO2%2F9Uq%2F37W77%2BH%2Bn44wWk4YPNbNk8JR6MuzxmO4HV8K7jLAeALS%2Bx%2Fgl33A9vL0S5nYpJzuJmbuh2yPlFQMIQSmPbZxOoPoysSVEtsOor%2FjIvlAuEDtdParkZWwa6pTEyi53VwWqcv40b8IPMRSNzkM11rW%2FUNej7Q4%2BYbtw1u8K%2F7Sw4SKonU%3D&X-Amz-Signature=cf54e08650bd919b92b6e58d19e5c4e1d22f28c5cddd365d5dc75076f4236f05&X-Amz-SignedHeaders=host",
  advancedModules: {
    modules: [
      {
        id: 1,
        key: "extraction",
        inner_title_key: "extraction",
        dataKey: "extraction",
        title: "Extraction",
        active: false,
      },
      {
        id: 2,
        key: "ipr",
        inner_title_key: "ipr_short",
        dataKey: "ipr",
        title: "Interproximal reduction",
        active: true,
      },
      {
        id: 3,
        key: "attachments",
        inner_title_key: "attachments",
        dataKey: "attachments",
        title: "Attachments",
        active: true,
      },
      {
        id: 4,
        key: "pontics",
        inner_title_key: "pontics",
        dataKey: "pontics",
        title: "Pontics",
        active: false,
      },
      {
        id: 5,
        key: "passive_aligners",
        inner_title_key: "passive_aligners",
        dataKey: "passiveAligners",
        title: "Passive Aligner",
        active: true,
      },
      {
        id: 6,
        key: "tooth_size_discrepancy",
        inner_title_key: "tooth_size_discrepancy",
        dataKey: "toothSizeDiscrepancy",
        title: "Tooth size Discrepancy",
        active: false,
      },
      {
        id: 7,
        key: "torque_enhancers",
        inner_title_key: "torque_enhancers",
        dataKey: "torqueEnhancers",
        title: "Torque Enhancers",
        active: true,
      },
      {
        id: 8,
        key: "bite_ramps",
        inner_title_key: "bite_ramps",
        dataKey: "biteRamps",
        title: "Bite Ramps",
        active: false,
      },
      {
        id: 9,
        key: "elastics",
        inner_title_key: "elastics",
        dataKey: "elastics",
        title: "Elastics",
        active: true,
      },
      {
        id: 10,
        key: "teeth_movement",
        inner_title_key: "teeth_movement",
        dataKey: "teethMovement",
        title: "Tooth movement rate",
        active: true,
      },
    ],
    tooth_size_discrepancy: {
      useModule: false,
      options: {},
    },
    torque_enhancers: {
      useModule: true,
      options: {
        teeth: {
          6: {
            from: "3",
            to: "26",
          },
        },
      },
    },
    arch_expansion: {
      useModule: false,
      options: {},
    },
    ap_discrepancies: {
      useModule: false,
      options: {},
    },
    spacing: {
      useModule: false,
      options: {},
    },
    vertical: {
      useModule: false,
      options: {},
    },
    transverse: {
      useModule: false,
      options: {},
    },
    elastics: {
      options: {
        teeth: {
          5: [
            {
              elastic: "cut",
              direction: "left",
              surface: "buccal",
              from: "1",
              to: "66",
              type: {
                value: "class_two",
                title: "Class Two Elastics",
                applied: "Class II",
              },
              className: "elastic-cut",
            },
          ],
          10: [
            {
              elastic: "cut",
              direction: "right",
              surface: "buccal",
              from: "1",
              to: "66",
              type: {
                value: "class_two",
                title: "Class Two Elastics",
                applied: "Class II",
              },
              className: "elastic-cut",
            },
          ],
          18: [
            {
              elastic: "button",
              surface: "buccal",
              side: "distal",
              from: "1",
              to: "66",
              type: {
                value: "class_two",
                title: "Class Two Elastics",
                applied: "Class II",
              },
              className: "elastic-button",
            },
          ],
          29: [
            {
              elastic: "button",
              side: "mesial",
              surface: "buccal",
              from: "1",
              to: "66",
              className: "elastic-button",
              type: {
                value: "class_two",
                title: "Class Two Elastics",
                applied: "Class II",
              },
            },
          ],
        },
      },
      useModule: true,
    },
    extraction: {
      useModule: false,
      options: {},
    },
    ipr: {
      useModule: true,
      options: {
        iprPosition: {
          2: {
            1: "0.2",
          },
          3: {
            1: "0.2",
          },
          4: {
            20: "0.3",
          },
          5: {
            1: "0.2",
          },
          6: {
            1: "0.3",
          },
          7: {
            20: "0.3",
          },
          8: {
            1: "0.3",
          },
          9: {
            20: "0.2",
          },
          10: {
            1: "0.3",
          },
          11: {
            1: "0.2",
          },
          12: {
            1: "0.2",
          },
        },
      },
    },
    attachments: {
      useModule: true,
      options: {
        teeth: {
          2: {
            buccal: "2",
          },
          3: {
            buccal: "2",
          },
          4: {
            buccal: "2",
          },
          5: {
            buccal: "2",
          },
          7: {
            buccal: "2",
          },
          8: {
            buccal: "2",
          },
          9: {
            buccal: "2",
          },
          10: {
            buccal: "2",
          },
          11: {
            buccal: "2",
          },
          12: {
            buccal: "2",
          },
          13: {
            buccal: "2",
          },
          17: {
            buccal: "2",
          },
          18: {
            buccal: "2",
          },
          19: {
            buccal: "2",
          },
          20: {
            buccal: "2",
          },
          21: {
            buccal: "2",
          },
          23: {
            buccal: "2",
          },
          24: {
            buccal: "2",
          },
          26: {
            buccal: "2",
          },
          27: {
            buccal: "2",
          },
          28: {
            buccal: "2",
          },
          29: {
            buccal: "2",
          },
        },
        primaryTeeth: {},
      },
    },
    pontics: {
      useModule: false,
      options: {},
    },
    overCorrection: {
      useModule: false,
      options: {},
    },
    bite_ramps: {
      useModule: false,
      options: {},
    },
    teeth_movement: {
      useModule: true,
      options: {
        teethGroups: "normal_rate",
      },
    },
    passive_aligners: {
      useModule: true,
      options: {
        teethGroups: "start_together",
        upperPassiveAligners: "39",
        lowerPassiveAligners: "0",
      },
    },
    options: {
      hasPrimaryTeeth: false,
      availablePrimaryTeeth: {},
    },
  },
  boltonAnalysisInfo: {
    toothWidthTable: {
      11: "9.08 mm",
      12: "6.84 mm",
      13: "8.16 mm",
      14: "7.67 mm",
      15: "6.93 mm",
      16: "10.94 mm",
      17: "10.54 mm",
      18: "",
      21: "9.62 mm",
      22: "7.05 mm",
      23: "8.06 mm",
      24: "7.36 mm",
      25: "6.21 mm",
      26: "9.50 mm",
      27: "9.88 mm",
      28: "8.64 mm",
      31: "5.80 mm",
      32: "6.41 mm",
      33: "7.09 mm",
      34: "7.82 mm",
      35: "7.76 mm",
      36: "11.38 mm",
      37: "10.12 mm",
      38: "12.87 mm",
      41: "5.95 mm",
      42: "6.40 mm",
      43: "6.93 mm",
      44: "7.93 mm",
      45: "7.87 mm",
      46: "9.93 mm",
      47: "11.38 mm",
      48: "",
    },
    anteriorRatio: "0.79",
    overAllRatio: "0.94",
    upperArchLength: "Actual arc length: 126.49 mm",
    lowerArchLength: "Actual arc length: 125.65 mm",
  },
  manufacturingNotes: "",
  createdAt: "2024-01-31T13:25:09.159Z",
  approvedAt: null,
  clientApprovedAt: null,
  convertedFilesUrl:
    "https://s3-eon-tsc-raw-dev.s3.eu-central-1.amazonaws.com/coldfix/processed/23127107TC.OMAR_7e556.glb?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIA2DDTJHHC65JH6RHY%2F20240201%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20240201T071851Z&X-Amz-Expires=604800&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEHcaDGV1LWNlbnRyYWwtMSJIMEYCIQDQABffZ%2BZozziD4Pp9Cg%2B4PbLkMeG0F5vV9rwxH2Ir5wIhALtCY%2F3KXaHiaYS0tAdcn0mxeIXQpVlGaBR5w9cBrMddKskFCEAQAxoMNjkzODc4OTk1Mzk3IgxZXujrA775njhI3SkqpgUmaA6intM%2FJV3A%2BGrfMzHY%2FaaBowTBAWPACWTlU8x%2BP35MOHgMZyKZAXgFzCtTljf%2BxZI3vQKmIJ6chsGt3EbW5LBRNpjkCa0eZA3NU4rXpd%2F6Ld5G%2Fg3nxvDPImQryQtUsEP5tSU3H3k922XWLnL9XSYsMAwIB7wv%2BNJb56pz4xGpljFv4NRGGi9st3U23slY7%2Fo1e0pDXCdTpqO7bNAWxwo5sXVRKaYp7rq7q3N4IVUvTMKQ0UQCWMT%2BSxHzfLNVcJbHqvMmUyDJf6S0ift8opzzFtPZfaoOKV6DFvnOGRzZv2nPfeVFcglWcf4TnXIQhPM8S%2BM1ncGdSBsyz5tCUW6W7SrNobGFqlr1WuYuyONiUKn%2FX6Mo6hCKxXCfQDo85GtdAKSoBRjOsqovEM%2F7fICFtSaJyM5T6%2Fk2ssso%2FKsEj6i8PycWp3AiHrf%2FnzlwyAoykpnJH75GxHKU6bDdePUy%2FBnGXXwaSia68f8rNEEpJH%2BfTV%2FNT%2FIgHGQA2D6opCTrQLCWVFK5rF6vXvCGEke7pq070F7ZwlOYhYnMvz8LZKxjzPrPMshLczdzp7d3Y8U%2FEen1GSvpKzHWNzRhGXW11qy2VwXSq64C7OsM%2FyuvBPZtBF2MM21wK4TLIWV4UakHjJepWD%2BtQEDnpCDOpA%2FqTbSyHyiBspcP8HydIH3e%2FSnvNcxYAGtdygbfSUQ%2BPFX04db5cJLOYP%2Fv%2Ftf72NWzvjzWgwzaRiPEKvZon8QnPRbPjzA4HJ7vT0jV3Oe1Kw%2BjJwtD6KC3s723SGYjGvNbrFO74ytkuLQVjH0TiCem33A%2Fb1hb9lRAI8%2F99LIs30XxJSSv2Pv0pxJhH7kpvZJyP2mc3j2sSwz03rajxfCQdncF5TYX8Hu%2FHV%2FgWRe0rk88taIwwvbsrQY64gIDDEeOUtE7GlIpfwvBpNPnGiDoKkFNIEYE2%2FXwMREE0Vh%2FZnKpUApp6uybAZHo7%2FgUN3q4I3u6wHWbUEPKDRnQHQAX1eV4kQktPGvOLVfFQVt23j3nc1DMZE35CYtpPqavWuqec4QtIEt%2F21%2BYqjoyyC3pGJ3x8bX9x2oSQlJJeeeaBlVgYlInbOWf2tJZfVG4Z7LucbUJ57z33k8h3YGeF8r09TyfgrdT1eW2ewXd40cGL9v7A6ng1sHJzBJMoHj1j3Xvl9N1k1U4CuRcls2R0DPdLnq2rmyImO2%2F9Uq%2F37W77%2BH%2Bn44wWk4YPNbNk8JR6MuzxmO4HV8K7jLAeALS%2Bx%2Fgl33A9vL0S5nYpJzuJmbuh2yPlFQMIQSmPbZxOoPoysSVEtsOor%2FjIvlAuEDtdParkZWwa6pTEyi53VwWqcv40b8IPMRSNzkM11rW%2FUNej7Q4%2BYbtw1u8K%2F7Sw4SKonU%3D&X-Amz-Signature=0745b94ff37325217208f0cf67381ec59ab090f0e11d7846ee1567b95680d842&X-Amz-SignedHeaders=host",
  reconverting: false,
  rawFileKey: "coldfix/raw/23127107TC.OMAR_7e556.zip",
  controlsRedoList: null,
  modificationsRequest: null,
  appliedModificationsNotes: null,
  isRefinementPlan: false,
  originalPlan: {},
  isViewerControlsEnabled: true,
  patientInfo: {
    firstName: "Test",
    lastName: "C82821",
  },
};
